/** Step 1's decorative icons, kept out of the pure view model. */
import React, { type ReactNode } from "react";
import { Share2, Users } from "lucide-react";
import type { AudienceApi } from "../../../services/distributions/distributions.types";

/** The audience cards' badges (prototype `AUD.icon`: users, share). */
export const AUDIENCE_ICONS: Readonly<Record<AudienceApi, ReactNode>> = {
  inside: <Users aria-hidden="true" />,
  outside: <Share2 aria-hidden="true" />,
};
